/* Copyright (C) 2021 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Mujica <jmujica@smartboxtv.com>
 */

import { action, flow } from 'mobx';
import fetch from '../fetch';
import ErrorsStore from './errorsStore';
import _ from '../translations';

class CreateAppStore {

    constructor() {
        this.baseUrl = '/api/core/apps';
    };

    @action.bound
    createApp = flow(function* (data) {
        try {
            const result = yield fetch.post({
                url: `${this.baseUrl}/createApp`,
                body: data,
            });
            return result
        } catch (e) {
            ErrorsStore.addError(e, _('Could not create app'));
            console.error('ERROR', e)
        };
    });

    @action.bound
    editApp = flow(function* (data) {
        try {
            const result = yield fetch.patch({
                url: `${this.baseUrl}/updateApp`,
                body: data,
            });
            return result
        } catch (e) {
            ErrorsStore.addError(e, _('Could not update app'));
            console.error('ERROR', e)
        };
    });

};

export default new CreateAppStore();